import React, { useState, useEffect } from "react";
import {
  AppProvider,
  LegacyCard,
  TextField,
  Select,
  InlineGrid,
  Spinner,
  Button,
  Icon,
  ChoiceList,
  Checkbox,
} from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";
import { useLibrary } from "./LibraryContext";
import { ArrowLeftIcon } from "@shopify/polaris-icons";
import CustomAutocomplete from "./CustomAutocomplete";
import JacketForm from "./OrderFrom/MenJacketForm";
import PantForm from "./OrderFrom/MenPantForm";
import VestForm from "./OrderFrom/MenVestForm";
import ShortForm from "./OrderFrom/MenShortForm";
import DrawstringPant from "./OrderFrom/DrawstringPant";
import DrawstringShort from "./OrderFrom/DrawstringShort";
import MenBomber from "./OrderFrom/MenBomber";
import MenJean from "./OrderFrom/MenJeanForm";
import PartsOrderLabel from "./OrderFrom/PartsOrderLabelForm";
import PartsOrderCuff from "./OrderFrom/PartsOrderCuffForm";
import WomenJacket from "./OrderFrom/WomenJacketForm";
import MenOvercoat from "./OrderFrom/MenOvercoatForm";
import ShirtLongSleeve from "./OrderFrom/ShirtLongSleeveForm";
import ShirtShortSleeve from "./OrderFrom/ShirtShortSleeveForm";
import WomenPantForm from "./OrderFrom/WomenPantForm";
import WomenVestForm from "./OrderFrom/WomenVestForm";
import WomenShortForm from "./OrderFrom/WomenShortForm";
import WomenOvercoatForm from "./OrderFrom/WomenOvercoatForm";
import WomenJeanForm from "./OrderFrom/WomenJeanForm";
import WomenShirtLongSleeveForm from "./OrderFrom/WomenShirtLongSleeveForm";
import WomenShirtShortSleeveForm from "./OrderFrom/WomenShirtShortSleeveForm";
import JacketMeasurements from "./Customers/JacketMeasurements";
import PantMeasurements from "./Customers/PantMeasurements";
import ShortPantMeasurements from "./Customers/ShortPantMeasurements";
import VestMeasurements from "./Customers/VestMeasurements";
import ShirtMeasurements from "./Customers/ShirtMeasurements";
import JeanMeasurements from "./Customers/JeanMeasurements";
import MenOvercoatMeasurements from "./Customers/MenOvercoatMeasurements";
import WomenJacketMeasurements from './Customers/WomenJacketMeasurements';
import WomenPantMeasurements from './Customers/WomenPantMeasurements';
import WomenShortMeasurements from './Customers/WomenShortMeasurements';
import WomenVestMeasurements from './Customers/WomenVestMeasurements';
import WomenShirtMeasurements from './Customers/WomenShirtMeasurements';
import WomenOvercoatMeasurements from './Customers/WomenOvercoatMeasurements';
import WomenJeanMeasurements from './Customers/WomenJeanMeasurements';
import TshirtForm from "./OrderFrom/TshirtForm";
import PalmJacketMeasurements from './Customers/PalmJacketMeasurements';
import PalmJacketForm from "./OrderFrom/PalmJacketForm";
import PartsOrderCollarForm from "./OrderFrom/PartsOrderCollarForm";
import PocketSquareForm from "./OrderFrom/PocketSquareForm";


export default function OrderCreate() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { fabrics: Fabrics, linings: LiningNumbers, tshirtFabrics: TshirtFabrics } = useLibrary();
  const location = useLocation();
  const customer = location.state?.customer;
  const CustomerIDS = customer.customerId;
  const customerUpdateId = customer._id;
  const [customererrors, setCustomerErrors] = useState({});

  const [form, setForm] = useState({
    Itemtype: "Men Suit",
    DateNeeded: "Normal",
    NeededDate: "",
    FabricNumber: "DBV133A",
    Qty: "1",
    measurementsUpdated: false,
    menjacket: {
      frontButton: "2 Button",
      shoulderPad: "Thin",
      bottomStyle: "Rounded",
      lapelStyle: "Notch",
      lapelWidth: '3 1/4"',
      handmadeLapelButtonhole: "Yes",
      backVent: "Side with Strap",
      chestPocket: "Welt",
      lowerPocket: "Regular",
      ticketPocket: "No",
      chestPocketSqaure: "Match Lining",
      contrast: "No",
      coveredButton: "No",
      sleeveButton: "4 Kissing",
      liningStyle: "Full",
      customLining: "No",
      customLiningTemplate: "",
      customLiningFile: [],
      liningNumber: "FLLPV106-6",
      buttonNumber: "KSZ153 Black Premium",
      threadContrastLapelButtonhole: "No",
      threadContrastLapelButtonholeYes: "C2740 Ivory",
      threadContrastSleeve: "No",
      pickStitch: '.05" Pick',
      threadContrastSleeveColor: "C2740 Ivory",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
      monograms: [],
      monogramDetails: {},
    },
    menpant: {
      frontStyle: "No Pleat",
      frontPocket: "Slant",
      backPocket: "Besom with Button",
      bottomStyle: "Regular",
      waistbandClosure: "Hook & Button",
      beltLoop: "Regular",
      sideTabs: "No",
      waistWidth: '1 1/2"',
      insideWaistband: "Snugtex",
      suspenderButtons: "No",
      contrastSideSeamThinPiping: "No",
      contrastSideSeamWide: "No",
      contrastWaistband: "No",
      contrastButtonCovered: "No",
      buttonNumber: "KSZ153 Black Premium",
      threadContrastSleeveColor: "C2740 Ivory",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
      monograms: [],
      monogramDetails: {},
    },
    menvest: {
      frontButton: "5 Button",
      bottom: "Regular Point",
      collar: "V Shape",
      lapelContrast: "No",
      lowerPocket: "Welt",
      chestPocket: "No",
      ticketPocket: "No",
      backFabric: "Fabric",
      insideLining: "FLLPV106-6",
      tuxedoWrap: "No",
      coveredButton: "No",
      buttonNumber: "KSZ153 Black Premium"
    },
    menShort: {
      frontStyle: "No Pleat",
      frontPocket: "Slant",
      backPocket: "Besom with Button",
      bottomStyle: "Regular",
      waistbandClosure: "Hook & Button",
      beltLoop: "Regular",
      sideTabs: "No",
      waistWidth: "1 1/2",
      buttonNumber: "KSZ153 Black Premium",
    },
    menBomber: {
      collarFabric: "Black- QLWB005",
      bottomFabric: "Black- QLWB005",
      cuffFabric: "Black- QLWB005",
      zipper: "Silver",
      customLining: "No",
      customLiningTemplate: "",
      customLiningFile: [],
      liningNumber: "FLLPV106-6",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
    },
    menJean: {
      button: "GKC04",
      thread: "A2750- WHITE",
      rivet: "MDC01",
      frontPocket: "Crescent",
      patchPocket: "Yes",
      backPocket: "Pentagon",
      washingStyle: "None",
    },
    menOvercoat: {
      frontButton: "3 Button",
      frontBottom: "Straight",
      lapelStyle: "Notch",
      LapelButtonhole: "Yes",
      backVent: "Center",
      chestPocket: "No",
      lowerPocket: "Welt Slanted",
      ticketPocket: "No",
      sleeveButton: "4 Kissing",
      contrast: "Lapel",
      liningStyle: "Full",
      liningNumber: "FLLPV106-6",
      buttonNumber: "KSZ153 Black Premium",
      threadContrastLapelButtonhole: "No",
      threadContrastLapelButtonholeYes: "C2740 Ivory",
      threadContrastSleeve: "No",
      threadContrastSleeveColor: "C2740 Ivory",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
      monograms: [],
      monogramDetails: {},
    },
    shirtLongSleeve: {
      collar: "MR Classic",
      pointLength: '2.75"',
      frontHeight: '1.25"',
      backHeight: '1"',
      buttonDown: "No",
      cuff: "1B Mitered",
      sleevePlacketButton: "Yes",
      pocket: "No",
      pocketFlap: "No",
      placket: "Placket",
      bottomStyle: "Round",
      collarContrast: "No",
      placketContrast: "No",
      cuffContrast: "No",
      buttonNumber: "KB045- WHITE PREMIUM",
      buttonholeThreadFront: "Match",
      buttonholeThreadCuff: "Match",
      monograms: [],
      monogramDetails: {},
    },
    shirtShortSleeve: {
      collar: "MR Classic",
      pointLength: '2.75"',
      frontHeight: '1.25"',
      backHeight: '1"',
      buttonDown: "No",
      cuff: "Plain",
      pocket: "No",
      pocketFlap: "No",
      placket: "Placket",
      bottomStyle: "Round",
      placketContrast: "No",
      buttonNumber: "KB045- WHITE PREMIUM",
      buttonholeThreadFront: "Match",
      monograms: [],
      monogramDetails: {},
    },
    drawstringPant: {
      waistband: "Full Elastic",
      drawstringColor: "White - QMD-D207-W003",
      buttonNumber: "KSZ153 Black Premium",
      backPocket: "Besom with Button",
      bottomHem: "Regular",
      drawstringHoles: "Inside Waistband",
    },
    drawstringShort: {
      drawstringColor: "White - QMD-D207-W003",
      buttonNumber: "KSZ153 Black Premium",
      backPocket: "Besom with Button",
    },
    partsOrderLabel: {
      orginalOrderNumber: "",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
    },
    partsOrderCuff: {
      orginalOrderNumber: "",
      cuff: "1B Mitered",
      nameLabelFont: "Caligraphy",
      color: "102 White",
      size: "Regular",
      nameLabelText: "",
    },
    partsOrderCollar: {
      orginalOrderNumber: "",
      collar: "MR Classic",
      pointLength: '2.75"',
      frontHeight: '1.25"',
      backHeight: '1"',
      buttonDown: "No",
      buttonNumber: "KSZ153 Black Premium",
      neckMeasurement: "",
    },
    pocketSquare: {
      liningNumber: "",
    },
    tshirt: {
      collar: "V-Neck",
      monograms: [],
      monogramDetails: {},
    },
    palmJacket: {
      zipper: "Silver",
      buttonNumber: "KSZ153 Black Premium",
    },
    womenjacket: {
      frontButton: "2 Button",
      shoulderPad: "Thin",
      bottomStyle: "Rounded",
      lapelStyle: "Notch",
      lapelWidth: '3 1/4"',
      handmadeLapelButtonhole: "Yes",
      backVent: "Central",
      chestPocket: "No",
      lowerPocket: "Besom with Flap",
      ticketPocket: "No",
      chestPocketSqaure: "None",
      contrast: "No",
      sleeveButton: "4 Kissing",
      liningStyle: "Full",
      customLining: "No",
      customLiningFile: [],
      liningNumber: "FLLPV106-6",
      coveredButton: "No",
      buttonNumber: "KSZ153 Black Premium",
      threadContrastLapelButtonhole: "No",
      threadContrastLapelButtonholeYes: "C2740 Ivory",
      threadContrastSleeve: "No",
      threadContrastSleeveColor: "C2740 Ivory",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
      monograms: [],
      monogramDetails: {},
    },
    womenpant: {
      frontStyle: "No Pleat",
      frontPocket: "Slant",
      backPocket: "Besom with Button",
      bottomStyle: "Regular",
      waistbandClosure: "Hook & Button",
      beltLoop: "Regular",
      sideTabs: "No",
      waistWidth: '1 1/2"',
      suspenderButtons: "No",
      contrastSideSeamThinPiping: "No",
      contrastSideSeamWide: "No",
      contrastWaistband: "No",
      contrastButtonCovered: "No",
      buttonNumber: "KSZ153 Black Premium",
    },
    womenvest: {
      frontButton: "5 Button",
      bottom: "Regular Point",
      collar: "V Shape",
      lapelContrast: "No",
      lowerPocket: "Welt",
      ticketPocket: "No",
      backFabric: "Fabric",
      insideLining: "FLLPV106-6",
      tuxedoWrap: "No",
      coveredButton: "No",
    },
    womenShort: {
      frontStyle: "No Pleat",
      frontPocket: "Slant",
      backPocket: "Besom with Button",
      bottomStyle: "Regular",
      waistbandClosure: "Hook & Button",
      beltLoop: "Regular",
      sideTabs: "No",
      waistWidth: "1 1/2",
      buttonNumber: "KSZ153 Black Premium",
    },
    womenJean: {
      fabric: "ZGA0025",
      button: "GKC04",
      thread: "A2750- WHITE",
      rivet: "MDC01",
      frontPocket: "Crescent",
      patchPocket: "Yes",
      backPocket: "Pentagon",
      washingStyle: "None",
    },
    womenOvercoat: {
      frontButton: "3 Button",
      frontBottom: "Straight",
      lapelStyle: "Notch",
      LapelButtonhole: "Yes",
      backVent: "Center",
      chestPocket: "No",
      lowerPocket: "Welt Slanted",
      ticketPocket: "No",
      sleeveButton: "4 Kissing",
      contrast: "Lapel",
      liningStyle: "Full",
      liningNumber: "FLLPV106-6",
      buttonNumber: "KSZ153 Black Premium",
      threadContrastLapelButtonhole: "No",
      threadContrastLapelButtonholeYes: "C2740 Ivory",
      threadContrastSleeve: "No",
      threadContrastSleeveColor: "C2740 Ivory",
      nameLabelFont: "Caligraphy",
      nameLabelColor: "102 White",
      nameLabelText: "",
      monograms: [],
      monogramDetails: {},
    },
    womenShirtLongSleeve: {
      collar: "MR Classic",
      pointLength: '2.75"',
      collarBand: "Rounded",
      cuff: "1B Mitered",
      pocket: "No",
      placket: "Placket",
      bottomStyle: "Round",
      collarContrast: "No",
      placketContrast: "No",
      cuffContrast: "No",
      buttonNumber: "KB045- WHITE PREMIUM",
      buttonholeThreadFront: "Match",
      buttonholeThreadCuff: "Match",
      monograms: [],
      monogramDetails: {},
    },
    womenShirtShortSleeve: {
      collar: "MR Classic",
      pointLength: '2.75"',
      collarBand: "Rounded",
      pocket: "No",
      placket: "Placket",
      bottomStyle: "Round",
      collarContrast: "No",
      placketContrast: "No",
      cuffContrast: "No",
      buttonNumber: "KB045- WHITE PREMIUM",
      buttonholeThreadFront: "Match",
      buttonholeThreadCuff: "Match",
      monograms: [],
      monogramDetails: {},
    },
    orderNotes: "",
    customer_id_row: "",
  });

  const [formCustomer, setformCustomer] = useState({
    name: "",
    gender: "Male",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "Alabama",
    pincode: "",
    country: "United States",
    measurements: {
      jacket: true,
      pant: false,
      shortPant: false,
      vest: false,
      shirt: false,
      jean: false,
      menOvercoat: false,
      womenJacket: false,
      womenPant: false,
      womenShort: false,
      womenVest: false,
      womenShirt: false,
      womenOvercoat: false,
      womenJean: false,
      palmJacket: false,
    },
    jacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    pant: {
      waist: "",
      seat: "",
      outseam: "",
      knee: "",
      bottom: "",
    },
    shortPant: {
      waist: "",
      seat: "",
      shortOutseam: "",
      shortBottom: "",
    },
    vest: {
      chest: "",
      stomach: "",
      backLength: "",
      frontLength: ""
    },
    shirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirttHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
      shirtSleeveLenghtL: "",
      shirtSleeveLenghtR: "",
      shortSleeveCuff: "",
    },
    jean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outseam: "",
    },
    menOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
    },
    womenPant: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenShort: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenVest: {
      chest: "",
      stomach: "",
      backLength: "",
      firstButton: "",
    },
    womenShirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirtHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
    },
    womenOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outSeam: "",
    },
    palmJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    bodyNotes: ["headForward"],
    fitType: "regular",
    customerNotes: "",
  });

  const [customerdata, setCustomerdata] = useState({
    name: "",
    id: "",
  });

  useEffect(() => {
    if (customer) {
      const customerOld = customer.json;
      setCustomerdata((prevForm) => ({
        ...prevForm,
        name: customer.json?.name || "",
        id: customer.customerId || "",
      }));
      setformCustomer(customerOld);
      setForm((prevForm) => ({
        ...prevForm,
        customer_id_row: customer._id || "",
      }));
    }
  }, [customer]);

  const [errors, setErrors] = useState({});
  const [apploader, setApploader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMeasurements, setloadingMeasurements] = useState({});
  const [messStatus, setMessStatus] = useState("");
  const navigate = useNavigate();
  const itemtype = [
    "Men Suit",
    "Men 3pc Suit",
    "Men Shirt Long Sleeve",
    "Men Shirt Short Sleeve",
    "Men Jacket",
    "Men Pant",
    "Men Short",
    "Men Vest",
    "Men Bomber",
    "Men Overcoat",
    "Men Jean",
    "Drawstring Pant",
    "Drawstring Short",
    "Women Suit",
    "Women 3pc Suit",
    "Women Jacket",
    "Women Pant",
    "Women Vest",
    "Women Shirt Long Sleeve",
    "Women Shirt Short Sleeve",
    "Women Sleeveless Shirt",
    "Women Short",
    "Women Overcoat",
    "Women Jean",
    "Parts Order Label",
    "Parts Order Cuff",
    "Parts Order Collar",
    "T-Shirt & Polo",
    "The Palm Jacket",
    "Pocket Square",
  ];

  const handleBack = () => {
    navigate(-1);
  };

  const itemTypeChange = (fieldName) => (selectedValue) => {
    const newItemType = Array.isArray(selectedValue) ? selectedValue[0] : selectedValue;
    setForm((prevForm) => {
      const wasTshirt = prevForm.Itemtype === "T-Shirt & Polo";
      const willBeTshirt = newItemType === "T-Shirt & Polo";
      const fabricListChanged = wasTshirt !== willBeTshirt;

      let newFabricNumber = prevForm.FabricNumber;
      if (fabricListChanged) {
        // Auto-select first fabric from the correct list
        newFabricNumber = willBeTshirt
          ? TshirtFabrics?.[0]?.value || ""
          : Fabrics?.[0]?.value || "";
      }

      // Auto-select first lining from LiningNumbers list when Pocket Square selected
      let newPocketSquare = prevForm.pocketSquare;
      if (newItemType === "Pocket Square") {
        newPocketSquare = {
          ...prevForm.pocketSquare,
          liningNumber:
            prevForm.pocketSquare?.liningNumber || LiningNumbers?.[0]?.value || "",
        };
      }

      return {
        ...prevForm,
        [fieldName]: newItemType,
        FabricNumber: newFabricNumber,
        pocketSquare: newPocketSquare,
      };
    });
  };

  const handleChange =
    (section, key = null) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          value = values[0];
        } else {
          value = values;
        }
        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }

        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const conditionalFieldsMap = {
    menvest: {
      coveredButton: {
        conditionValue: "Satin Number",
        dependentKey: "coveredButtonSatin",
      },
      tuxedoWrap: {
        conditionValue: "Yes",
        dependentKey: "tuxedoWrapSatin",
      },
      backFabric: {
        conditionValue: "Lining Specify",
        dependentKey: "backFabricLining",
      },
      lapelContrast: {
        conditionValue: ["Lapel", "Lapel edge"],
        dependentKey: "lapelContrastLapel",
      },
    },
    menjacket: {
      chestPocketSqaure: {
        conditionValue: "Other",
        dependentKey: "chestPocketSqaureOther",
      },
      liningNumber: {
        conditionValue: "Custom Images",
        dependentKey: "liningNumberFile",
      },
      nameLabelFont: {
        conditionValue: "Custom Upload",
        dependentKey: "nameLabelFontFile",
      },
    },
  };

  const itemtypeSectionMap = {
    "Men Jacket": "menjacket",
    "Men Suit": ["menjacket", "menpant"],
    "Men Pant": "menpant",
    "Men Short": "menShort",
    "Men Vest": "menvest",
    "Men Bomber": "menBomber",
    "Men Jean": "menJean",
    "Drawstring Pant": "drawstringPant",
    "Drawstring Short": "drawstringShort",
    "Parts Order Label": "partsOrderLabel",
    "Parts Order Cuff": "partsOrderCuff",
    "Men 3pc Suit": ["menjacket", "menpant", "menVest"],
    "Women Suit": ["womenjacket", "womenpant"],
    "Women 3pc Suit": ["womenjacket", "womenpant", "womenvest"],
    "Women Jacket": "womenjacket",
    "Men Overcoat": "menOvercoat",
    "Men Shirt Short Sleeve": "shirtShortSleeve",
    "Men Shirt Long Sleeve": "shirtLongSleeve",
    "Women Pant": "womenpant",
    "Women Vest": "womenvest",
    "Women Short": "womenShort",
    "Women Overcoat": "womenOvercoat",
    "Women Jean": "womenJean",
    "Women Shirt Long Sleeve": "womenShirtLongSleeve",
    "Women Shirt Short Sleeve": "womenShirtShortSleeve",
    "Women Sleeveless Shirt": "womenSleevelessShirt",
    "T-Shirt & Polo": "tshirt",
    "The Palm Jacket": "palmJacket",
    "Parts Order Collar": "partsOrderCollar",
    "Pocket Square": "pocketSquare"

  };

  const validate = () => {
    const newErrors = {};

    if (
      (form.DateNeeded === "Event Date" || form.DateNeeded === "Urgent Rush") &&
      !form.NeededDate
    ) {
      newErrors.NeededDate = "Required";
    }

    // Get section(s) for the selected item type
    const selectedSections = itemtypeSectionMap[form.Itemtype];

    // Always work with array (whether it's single or multiple sections)
    const sectionList = Array.isArray(selectedSections)
      ? selectedSections
      : [selectedSections];

    sectionList.forEach((section) => {
      if (!form[section]) return;

      const sectionFields = form[section];

      // Validate empty fields
      Object.entries(sectionFields).forEach(([key, value]) => {
        const nameLabelFont = sectionFields.nameLabelFont;
        const nameLabelFontFile = sectionFields.nameLabelFontFile;

        if (
          key === "nameLabelText" &&
          nameLabelFont === "Custom Upload" &&
          nameLabelFontFile
        ) {
          return;
        }

        // Skip customLiningTemplate / customLiningFile when Custom Lining is not Yes
        if (
          (key === "customLiningTemplate" || key === "customLiningFile") &&
          sectionFields.customLining !== "Yes"
        ) {
          return;
        }

        if (!value || value === "") {
          if (!newErrors[section]) newErrors[section] = {};
          newErrors[section][key] = "Required";
        }

        // ✅ Additional logic for monogramDetails
        if (key === "monogramDetails" && typeof value === "object") {
          Object.entries(value).forEach(([monogramKey, monogram]) => {
            const font = monogram.font;
            const text = monogram.text;

            // Agar font 'Custom Upload' nahi hai, to text required hai
            if (font !== "Custom Upload" && (!text || text.trim() === "")) {
              if (!newErrors[section]) newErrors[section] = {};
              if (!newErrors[section]["monogramDetails"]) {
                newErrors[section]["monogramDetails"] = {};
              }
              newErrors[section]["monogramDetails"][monogramKey] = {
                text: "Required",
              };
            }
          });
        }

      });


      // Conditional validation
      const conditionalRules = conditionalFieldsMap[section] || {};
      Object.entries(conditionalRules).forEach(([key, rule]) => {
        const { conditionValue, dependentKey } = rule;
        const fieldValue = sectionFields[key];

        const conditionMet = Array.isArray(conditionValue)
          ? conditionValue.includes(fieldValue)
          : fieldValue === conditionValue;

        if (conditionMet && !sectionFields[dependentKey]) {
          if (!newErrors[section]) newErrors[section] = {};
          newErrors[section][dependentKey] = "Required";
        }
      });
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const getFilteredFormData = () => {
    const itemType = form.Itemtype;
    const sectionKeys = itemtypeSectionMap[itemType];
    const keysArray = Array.isArray(sectionKeys) ? sectionKeys : [sectionKeys];

    const filteredData = {
      Itemtype: form.Itemtype,
      DateNeeded: form.DateNeeded,
      NeededDate: form.NeededDate,
      FabricNumber: form.FabricNumber,
      Qty: form.Qty,
      measurementsUpdated: form.measurementsUpdated || false,
      orderNotes: form.orderNotes,
      customer_id_row: form.customer_id_row,
    };

    keysArray.forEach((key) => {
      filteredData[key] = form[key];
    });

    return filteredData;
  };


  const handleSubmit = (orderType) => {
    if (!validate()) return;
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const repsName = decoded.name;
    const adminrole = decoded.role;
    const RepsId = decoded.ids;

    if (!token) {
      return;
    }
    setLoading(true);
    const dataToSend = getFilteredFormData();
    const updatedForm = {
      ...dataToSend,
      adminrole: adminrole,
      repsid: RepsId,
      repName: repsName,
      CustomerID: CustomerIDS,
      customerName: customerdata.name,
      orderStatus: orderType,
    };

    fetch(`${baseUrl}/api/orders/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedForm),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "order created failed!");
        }
        setMessStatus(`Order has been created successfully.`);
        setTimeout(function () {
          navigate("/dashboard/orders");
        }, 2000);
      })
      .catch((error) => {
        setMessStatus(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Customer Measurements Validate
  const typeCheckName = form?.Itemtype;
  const Customervalidate = (form, sectionKey) => {
    const newErrors = {};
    const updatedErrors = { ...form.customerErrors };
    if (form.measurements[sectionKey]) {
      Object.entries(form[sectionKey]).forEach(([subKey, value]) => {
        if (sectionKey === "jacket" && subKey === "firstButtonPlacement") return;
        if (sectionKey === "womenVest" && subKey === "firstButton") return;
        if ((sectionKey === "vest" && subKey === "firstButtonPlacement") || subKey === "frontLength") return;
        if (typeCheckName === "Men Shirt Long Sleeve") {
          if (
            (sectionKey === "shirt" && subKey === "shirtSleeveLenghtL") ||
            subKey === "shirtSleeveLenghtR" ||
            subKey === "shortSleeveCuff"
          )
            return;
        }
        if (typeCheckName === "Men Shirt Short Sleeve" || typeCheckName === "T-Shirt & Polo") {
          if (
            (sectionKey === "shirt" && subKey === "sleeveL") ||
            subKey === "sleeveR" || subKey === "cuffR" ||
            subKey === "cuffL"
          )
            return;
        }
        if (!value) {
          if (!newErrors[sectionKey]) newErrors[sectionKey] = {};
          newErrors[sectionKey][subKey] = "Required";
        } else {
          if (updatedErrors[sectionKey]?.[subKey]) {
            delete updatedErrors[sectionKey][subKey];
            if (Object.keys(updatedErrors[sectionKey]).length === 0) {
              delete updatedErrors[sectionKey];
            }
          }
        }
      });
    }

    // Object.entries(form[key]).forEach(([subKey, value]) => {
    //   if (key === "jacket" && subKey === "firstButtonPlacement") return;
    //   if (key === "womenVest" && subKey === "firstButton") return;
    //   if ((key === "vest" && subKey === "firstButtonPlacement") || subKey === "frontLength") return;
    //   if (
    //     (key === "shirt" && subKey === "shirtSleeveLenghtL") ||
    //     subKey === "shirtSleeveLenghtR" ||
    //     subKey === "shortSleeveCuff"
    //   )
    //     return;
    //   if (!value) {
    //     if (!newErrors[key]) newErrors[key] = {};
    //     newErrors[key][subKey] = "Required";
    //   }
    // });


    setCustomerErrors({ ...updatedErrors, ...newErrors });
    return Object.keys(newErrors).length === 0;
  };


  // Customer Measurements Submit
  const [customerMess, setCustomerMess] = useState({});
  const CustomerhandleSubmit = (sectionKey) => {
    const updatedFormData = {
      ...formCustomer,
      measurements: {
        ...formCustomer.measurements,
        [sectionKey]: true,
      },
    };
    setformCustomer(updatedFormData);
    if (!Customervalidate(updatedFormData, sectionKey)) return;

    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const adminrole = decoded.role;
    if (!token) {
      return;
    }

    setloadingMeasurements((prev) => ({ ...prev, [sectionKey]: true }));
    const updatedForm = {
      ...updatedFormData,
      adminrole: adminrole,
    };

    fetch(`${baseUrl}/api/customers/${customerUpdateId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedForm),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "update failed!");
        }
        setCustomerMess((prev) => ({
          ...prev,
          [sectionKey]: "Saved successfully!",
        }));
      })
      .catch((error) => {
        setCustomerMess((prev) => ({
          ...prev,
          [sectionKey]: error.message,
        }));
      })
      .finally(() => {
        setloadingMeasurements((prev) => ({ ...prev, [sectionKey]: false }));
        setTimeout(() => {
          setCustomerMess((prev) => ({
            ...prev,
            [sectionKey]: "",
          }));
        }, 3000);
      });
  };


  return (
    <AppProvider i18n={en}>
      <div className="button_option">
        <h2>
          <span onClick={handleBack}>
            <Icon source={ArrowLeftIcon} tone="base" />
          </span>
          Create Order
        </h2>
      </div>
      <LegacyCard title="Customer Information" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
          <TextField
            label="Full Name"
            value={customerdata.name}
            placeholder="Name"
            readOnly
          />
          <TextField
            label="Customer ID"
            value={customerdata.id}
            placeholder="Name"
            readOnly
          />
        </InlineGrid>
      </LegacyCard>
      <LegacyCard title="Basic Information" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="400">
          <Select
            label="Item Type"
            options={itemtype}
            onChange={itemTypeChange("Itemtype")}
            value={form.Itemtype}
          />
          {form.Itemtype !== "Pocket Square" && (
            <CustomAutocomplete
              label="Fabric Number"
              optionsList={form.Itemtype === "T-Shirt & Polo" ? TshirtFabrics : Fabrics}
              onChange={handleChange("FabricNumber")}
              defaultValue={form.FabricNumber}
            />
          )}
          <div className="two_culumn">
            <Select
              label="Date Needed"
              options={["Normal", "Event Date", "Urgent Rush"]}
              onChange={handleChange("DateNeeded")}
              value={form.DateNeeded}
            />
            {form.DateNeeded === "Event Date" ||
              form.DateNeeded === "Urgent Rush" ? (
              <TextField
                label="Date"
                value={form.NeededDate}
                onChange={handleChange("NeededDate")}
                error={errors.NeededDate}
                placeholder="MM-DD-YYYY"
              />
            ) : null}
          </div>
        </InlineGrid>
      </LegacyCard>

      {form?.Itemtype && !["Parts Order Label", "Parts Order Cuff", "Parts Order Collar", "Pocket Square"].includes(form?.Itemtype) && (
        <div className="customer_body_option view-mode-readonly">
          <LegacyCard title="Body Notes" sectioned>
            <ChoiceList
              allowMultiple
              choices={[
                { label: "Head Forward", value: "Head Forward" },
                { label: "Left Shoulder Down", value: "Left Shoulder Down" },
                { label: "Right Shoulder Down", value: "Right Shoulder Down" },
                { label: "Left Shoulder Up", value: "Left Shoulder Up" },
                { label: "Right Shoulder Up", value: "Right Shoulder Up" },
                { label: "Humpback", value: "Humpback" },
                { label: "Arms Forward", value: "Arms Forward" },
                { label: "Arms Backward", value: "Arms Backward" },
                { label: "Chest Out", value: "Chest Out" },
                { label: "Stomach Out", value: "Stomach Out" },
                { label: "Large Bicep", value: "Large Bicep" },
                { label: "Large Calf", value: "Large Calf" },
              ]}
              selected={formCustomer?.bodyNotes || []}
              onChange={() => {}}
            />
          </LegacyCard>
        </div>
      )}

      {form?.Itemtype && !["Parts Order Label", "Parts Order Cuff", "Parts Order Collar", "Pocket Square"].includes(form?.Itemtype) && (
        <LegacyCard title="Measurements Updated" sectioned>
          <Checkbox
            label="Measurements Updated For This Order"
            checked={form.measurementsUpdated || false}
            onChange={(val) => setForm({ ...form, measurementsUpdated: val })}
          />
        </LegacyCard>
      )}

      {["Men Suit", "Men 3pc Suit", "Men Jacket", "Men Bomber"].includes(form?.Itemtype) && (
        <JacketMeasurements
          values={formCustomer.jacket}
          message={customerMess.jacket}
          loading={loadingMeasurements.jacket}
          onSave={() => CustomerhandleSubmit("jacket")}
          errors={customererrors.jacket}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              jacket: { ...prev.jacket, [key]: value },
            }))
          }
        />
      )}

      {["Men Vest", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <VestMeasurements
          values={formCustomer.vest}
          message={customerMess.vest}
          loading={loadingMeasurements.vest}
          onSave={() => CustomerhandleSubmit("vest")}
          errors={customererrors.vest}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              vest: { ...prev.vest, [key]: value },
            }))
          }
        />
      )}

      {["Men Suit", "Men 3pc Suit", "Men Pant", "Drawstring Pant"].includes(form?.Itemtype) && (
        <PantMeasurements
          values={formCustomer.pant}
          message={customerMess.pant}
          loading={loadingMeasurements.pant}
          onSave={() => CustomerhandleSubmit("pant")}
          errors={customererrors.pant}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              pant: { ...prev.pant, [key]: value },
            }))
          }
        />
      )}

      {["Men Short", "Drawstring Short"].includes(form?.Itemtype) && (
        <ShortPantMeasurements
          values={formCustomer.shortPant}
          message={customerMess.shortPant}
          loading={loadingMeasurements.shortPant}
          onSave={() => CustomerhandleSubmit("shortPant")}
          errors={customererrors.shortPant}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              shortPant: { ...prev.shortPant, [key]: value },
            }))
          }
        />
      )}


      {["Men Shirt Short Sleeve", "Men Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <ShirtMeasurements
          values={formCustomer.shirt}
          message={customerMess.shirt}
          loading={loadingMeasurements.shirt}
          onSave={() => CustomerhandleSubmit("shirt")}
          errors={customererrors.shirt}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              shirt: { ...prev.shirt, [key]: value },
            }))
          }
          dataType={form.Itemtype}
        />
      )}

      {["Men Jean"].includes(form?.Itemtype) && (
        <JeanMeasurements
          values={formCustomer.jean}
          message={customerMess.jean}
          loading={loadingMeasurements.jean}
          onSave={() => CustomerhandleSubmit("jean")}
          errors={customererrors.jean}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              jean: { ...prev.jean, [key]: value },
            }))
          }
        />
      )}

      {["Men Overcoat"].includes(form?.Itemtype) && (
        <MenOvercoatMeasurements
          values={formCustomer.menOvercoat}
          message={customerMess.menOvercoat}
          loading={loadingMeasurements.menOvercoat}
          onSave={() => CustomerhandleSubmit("menOvercoat")}
          errors={customererrors.menOvercoat}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              menOvercoat: { ...prev.menOvercoat, [key]: value },
            }))
          }
        />
      )}

      {["Women Jacket", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenJacketMeasurements
          values={formCustomer.womenJacket}
          message={customerMess.womenJacket}
          loading={loadingMeasurements.womenJacket}
          onSave={() => CustomerhandleSubmit("womenJacket")}
          errors={customererrors.womenJacket}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenJacket: { ...prev.womenJacket, [key]: value },
            }))
          }
        />
      )}

      {["Women Pant", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenPantMeasurements
          values={formCustomer.womenPant}
          message={customerMess.womenPant}
          loading={loadingMeasurements.womenPant}
          onSave={() => CustomerhandleSubmit("womenPant")}
          errors={customererrors.womenPant}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenPant: { ...prev.womenPant, [key]: value },
            }))
          }
        />
      )}

      {["Women Short"].includes(form?.Itemtype) && (
        <WomenShortMeasurements
          values={formCustomer.womenShort}
          message={customerMess.womenShort}
          loading={loadingMeasurements.womenShort}
          onSave={() => CustomerhandleSubmit("womenShort")}
          errors={customererrors.womenShort}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenShort: { ...prev.womenShort, [key]: value },
            }))
          }
        />
      )}

      {["Women Vest", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenVestMeasurements
          values={formCustomer.womenVest}
          message={customerMess.womenVest}
          loading={loadingMeasurements.womenVest}
          onSave={() => CustomerhandleSubmit("womenVest")}
          errors={customererrors.womenVest}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenVest: { ...prev.womenVest, [key]: value },
            }))
          }
        />
      )}

      {["Women Shirt", "Women Shirt Short Sleeve", "Women Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <WomenShirtMeasurements
          values={formCustomer.womenShirt}
          message={customerMess.womenShirt}
          loading={loadingMeasurements.womenShirt}
          onSave={() => CustomerhandleSubmit("womenShirt")}
          errors={customererrors.womenShirt}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenShirt: { ...prev.womenShirt, [key]: value },
            }))
          }
        />
      )}

      {["Women Overcoat"].includes(form?.Itemtype) && (
        <WomenOvercoatMeasurements
          values={formCustomer.womenOvercoat}
          message={customerMess.womenOvercoat}
          loading={loadingMeasurements.womenOvercoat}
          onSave={() => CustomerhandleSubmit("womenOvercoat")}
          errors={customererrors.womenOvercoat}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenOvercoat: { ...prev.womenOvercoat, [key]: value },
            }))
          }
        />
      )}

      {["Women Jean"].includes(form?.Itemtype) && (
        <WomenJeanMeasurements
          values={formCustomer.womenJean}
          message={customerMess.womenJean}
          loading={loadingMeasurements.womenJean}
          onSave={() => CustomerhandleSubmit("womenJean")}
          errors={customererrors.womenJean}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenJean: { ...prev.womenJean, [key]: value },
            }))
          }
        />
      )}

      {["T-Shirt & Polo"].includes(form?.Itemtype) && (
        <ShirtMeasurements
          values={formCustomer.shirt}
          message={customerMess.shirt}
          loading={loadingMeasurements.shirt}
          onSave={() => CustomerhandleSubmit("shirt")}
          errors={customererrors.shirt}
          dataType="T-Shirt & Polo"
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              shirt: { ...prev.shirt, [key]: value },
            }))
          }
        />
      )}

      {["The Palm Jacket"].includes(form?.Itemtype) && (
        <PalmJacketMeasurements
          values={formCustomer.palmJacket}
          message={customerMess.palmJacket}
          loading={loadingMeasurements.palmJacket}
          onSave={() => CustomerhandleSubmit("palmJacket")}
          errors={customererrors.palmJacket}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              palmJacket: { ...prev.palmJacket, [key]: value },
            }))
          }
        />
      )}

      {["Men Jacket", "Men Suit", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <JacketForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Vest", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <VestForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Pant", "Men Suit", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <PantForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}

      {["Men Short"].includes(form?.Itemtype) && (
        <ShortForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Short"].includes(form?.Itemtype) && (
        <WomenShortForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Drawstring Pant"].includes(form?.Itemtype) && (
        <DrawstringPant
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Drawstring Short"].includes(form?.Itemtype) && (
        <DrawstringShort
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Bomber"].includes(form?.Itemtype) && (
        <MenBomber
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Jean"].includes(form?.Itemtype) && (
        <MenJean
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Jean"].includes(form?.Itemtype) && (
        <WomenJeanForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Parts Order Label"].includes(form?.Itemtype) && (
        <PartsOrderLabel
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Parts Order Cuff"].includes(form?.Itemtype) && (
        <PartsOrderCuff
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Parts Order Collar"].includes(form?.Itemtype) && (
        <PartsOrderCollarForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {["Pocket Square"].includes(form?.Itemtype) && (
        <PocketSquareForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {["T-Shirt & Polo"].includes(form?.Itemtype) && (
        <TshirtForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
        />
      )}
      {["The Palm Jacket"].includes(form?.Itemtype) && (
        <PalmJacketForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {["Women Jacket", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenJacket
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Pant", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenPantForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Vest", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenVestForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}

      {["Men Overcoat"].includes(form?.Itemtype) && (
        <MenOvercoat
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Overcoat"].includes(form?.Itemtype) && (
        <WomenOvercoatForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <ShirtLongSleeve
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <WomenShirtLongSleeveForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Shirt Short Sleeve"].includes(form?.Itemtype) && (
        <ShirtShortSleeve
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Shirt Short Sleeve"].includes(form?.Itemtype) && (
        <WomenShirtShortSleeveForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      <LegacyCard title="Quantity" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
          <TextField
            label=""
            type="number"
            min="1"
            value={form.Qty}
            onChange={handleChange("Qty")}
            placeholder="1"
            autoComplete="off"
          />
        </InlineGrid>
      </LegacyCard>
      <LegacyCard title="NOTES" sectioned>
        <InlineGrid columns={1} gap="300">
          <div className="order_notes">
            <TextField
              value={form.orderNotes}
              onChange={handleChange("orderNotes")}
              error={errors.orderNotes}
              placeholder="Add your notes here..."
            />
          </div>
        </InlineGrid>
      </LegacyCard>

      {messStatus && <p className="sucess_mess">{messStatus}</p>}
      <div className="customerAddBtn">
        {!loading ? (
          <><Button variant="primary" onClick={() => handleSubmit("Draft")}>
            Save Draft
          </Button><Button variant="primary" onClick={() => handleSubmit("Submitted")}>
              Submit Order
            </Button></>
        ) : (
          <Spinner accessibilityLabel="Adding customer" size="small" />
        )}
      </div>
      {apploader ? (
        <div className="app_loader">
          <Spinner accessibilityLabel="Adding customer" size="small" />
        </div>
      ) : null}
    </AppProvider>
  );
}